// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { BasicRole, BasicRoleSchema } from 'api/gen/BasicRole';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { PageMetadata, PageMetadataSchema } from 'api/gen/PageMetadata';

const requiredPart = t.interface({
  content: t.union([t.array(BasicRoleSchema), t.null]),
  page: t.union([PageMetadataSchema, t.null]),
});

export const PagedModelBasicRoleSchema = excess(requiredPart);

export interface PagedModelBasicRole extends t.TypeOf<typeof PagedModelBasicRoleSchema> {}
